import { Injectable } from '@angular/core';
 
@Injectable()
export class TestProvider {
  reasonToJoin() {
    return 'test!';
  }
}
